/* eslint-disable */
import Api from '@/services/Api'

export default {

    getAll(prevId, prevDate, limit, search){
        try {
            console.log("Course GetAll");

            return Api().get('course/all/?prev_id='+prevId+'&prev_date='+prevDate+'&limit='+limit+'&search='+search);
        }catch(err){
            console.log(err);
            return err
        }
    },

    adminAll(prevId, prevDate, limit, search, adminId){
        try {
            console.log("Regular Admin Interaction GetAll");
            return Api().get('interaction/admin/?prev_id='+prevId+'&prev_date='+prevDate+'&limit='+limit+'&search='+search+'&admin_id='+adminId.Int64);
        }catch(err){
            console.log(err);
            return err
        }
    },
    pushData(){
        try {
            console.log("pushData");

            return Api().get('interaction/data/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    ResyncRaw(){
        try {
            console.log("ResyncRaw");

            return Api().get('interaction/raw/resync');
        }catch(err){
            console.log(err);
            return err
        }
    },
    UpdateStudentEmails(){
        try {
            console.log("UpdateStudentEmails");

            return Api().get('admin/student/gsheet/email');
        }catch(err){
            console.log(err);
            return err
        }
    },
}
